export const MAP_ACTION = {
  MAP: "map",
  NO_MAP: "noMap",
} as const;
